export const PAGE_DISPLAY_NAME = 'Specs & Features';
export const URL_PATH = 'features-specs';

export const CUSTOM_MAPPING = {
  'Towing & Hauling': [
    {
      label: 'Max Towing Capacity',
      featureName: 'Maximum towing capacity',
      featureCategory: 'Measurements',
    },
    {
      label: 'Max Payload Capacity',
      featureName: 'Maximum payload',
      featureCategory: 'Measurements',
    },
  ],
};

export const OVERVIEW_MAPPING = {
  EV: [
    {
      label: 'Electric Range',
      featureName: 'EPA electricity range',
      featureCategory: 'Fuel',
    },
    {
      label: 'Home Charging Time (240V)',
      featureName: 'EPA time to charge battery (at 240V)',
      featureCategory: 'Fuel',
    },
  ],
  PHEV: [
    {
      label: 'All Electric Range',
      featureName: 'EPA electricity range',
      featureCategory: 'Fuel',
    },
    {
      label: 'Combined MPG',
      description: '(when battery is drained)',
      featureName: 'EPA combined MPG',
      featureCategory: 'Fuel',
    },
  ],
  Gas: [
    {
      label: 'Combined MPG',
      featureName: 'EPA combined MPG',
      featureCategory: 'Fuel',
    },
  ],
};

export const BASIC_MAPPING = {
  // isTruck
  true: [
    {
      label: 'Drive Type',
      featureName: 'Drive type',
      featureCategory: 'Drive Train',
    },
    {
      label: 'Total Seating',
      topLevelKey: 'totalSeating',
    },
    {
      label: 'Bed length',
      featureName: 'Bed length',
      featureCategory: 'Measurements',
    },
    {
      label: 'Payload Capacity',
      featureName: 'Maximum payload',
      featureCategory: 'Measurements',
    },
    {
      label: 'Towing Capacity',
      featureName: 'Maximum towing capacity',
      featureCategory: 'Measurements',
    },
    {
      label: 'Curb Weight',
      featureName: 'Curb weight',
      featureCategory: 'Measurements',
      fallback: {
        label: 'Gross Weight',
        featureName: 'Gross weight',
        featureCategory: 'Measurements',
      },
    },
    {
      label: 'Basic Warranty',
      featureName: 'Basic',
      featureCategory: 'Warranty',
    },
    {
      label: 'Country of final assembly',
      featureName: 'Country of final assembly',
      featureCategory: 'Measurements',
    },
  ],
  // !isTruck
  false: [
    {
      label: 'Drive Type',
      featureName: 'Drive type',
      featureCategory: 'Drive Train',
    },
    {
      label: 'Total Seating',
      topLevelKey: 'totalSeating',
    },
    {
      label: 'Cargo Capacity',
      featureName: 'Cargo capacity, all seats in place',
      featureCategory: 'Measurements',
    },
    {
      label: 'Curb Weight',
      featureName: 'Curb weight',
      featureCategory: 'Measurements',
      fallback: {
        label: 'Gross Weight',
        featureName: 'Gross weight',
        featureCategory: 'Measurements',
      },
    },
    {
      label: 'Basic Warranty',
      featureName: 'Basic',
      featureCategory: 'Warranty',
    },
    {
      label: 'Country of final assembly',
      featureName: 'Country of final assembly',
      featureCategory: 'Measurements',
    },
  ],
};

export const COLORS_FEATURES = [{ name: 'Exterior Colors' }, { name: 'Interior Colors' }];

export const FEATURE_DISPLAY_NAMES = {
  '180 watts stereo output': '180-watt audio output',
  '160 watts stereo output': '160-watt audio output',
  'EV battery': 'EV Battery',
};

export const SECTION_DISPLAY_NAMES = {
  'Drive Train': 'Drivetrain',
  Frontseats: 'Front Seat Dimensions',
  Rearseats: 'Rear Seat Dimensions',
  Fuel: 'Fuel & MPG',
  'Tires and Wheels': 'Tires & Wheels',
  'In Car Entertainment': 'In-Car Entertainment',
  Measurements: 'Dimensions',
};

export const EV_SECTION_DISPLAY_NAMES = {
  ...SECTION_DISPLAY_NAMES,
  Fuel: 'Battery & Range',
};

export const OLD_SAFETY_FORMAT_LAST_VEHICLE_YEAR = 2000;

export const OLD_SAFETY_FORMAT_FEATURE_LABELS = {
  O: 'Optional',
  S: 'Standard',
  N: 'Not available',
};

export const NON_NUMBER_FEATURES = ['Fast-charge port type'];
